import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["prev", "prevButton", "prevCounter", "next", "nextButton", "nextCounter", "viewer"]

  connect () {
    if (!this.data.has("index")) {
      this.toggleMode(true)
      const section = document.location.hash.substring(1)
      const index = this.sections.findIndex(s => s === section)
      this.current = Math.max(0, index)
    }
  }

  toggleMode (mode) {
    this.prevTarget.classList.toggle("slides__prev--visible", mode)
    this.nextTarget.classList.toggle("slides__next--visible", mode)
    this.viewerTarget.classList.toggle("slides__viewer", mode)
  }

  navigate ({ key }) {
    switch (key) {
      case "a":
        this.toggleMode(false)
        break
      case "s":
        this.toggleMode(true)
        break
      case "ArrowRight":
      case "n":
        this.next()
        break
      case "ArrowLeft":
      case "p":
        this.prev()
        break
    }
  }

  recordOrigin ({ changedTouches: [{ screenX, screenY }] }) {
    this.originX = screenX
    this.originY = screenY
  }

  swipe ({ changedTouches: [{ screenX, screenY }] }) {
    if (Math.abs(screenY - this.originY) > Math.abs(screenX - this.originX)) return

    if (screenX < this.originX) {
      this.next()
    } else {
      this.prev()
    }
  }

  prev () {
    this.current = Math.max(0, this.current - 1)
  }

  next () {
    this.current = Math.min(this.last, this.current + 1)
  }

  get current () {
    return parseInt(this.data.get("index")) || 0
  }

  set current (index) {
    this.data.set("index", index)
    this.element.style.setProperty("--slides-current", this.current)
    this.prevButtonTarget.disabled = this.current === 0
    this.prevCounterTarget.innerText = this.current
    this.nextButtonTarget.disabled = this.current === this.last
    this.nextCounterTarget.innerText = this.last - this.current
    if (this.sections[index]) {
      history.replaceState(history.state, "", `#${this.sections[index]}`)
    }
  }

  get last () {
    return this.viewerTarget.querySelectorAll("section").length - 1
  }

  get sections () {
    return [...this.viewerTarget.querySelectorAll("[id]")].map(({ id }) => id)
  }
}
